<template>
  <div class="background-container">

    <div class="video-container bg-verde-md">
    <video autoplay muted loop>
      <source src="../assets/video-awa.mp4" type="video/mp4">
      <!-- source src="../assets/bg_nuvens.mp4" type="video/mp4" -->
      
      Seu navegador não suporta o formato de vídeo.
    </video>
    </div>


    <!-- Header com logo e menu -->
    <header class="header">
      <img src="../assets/logo-awa-header.svg" class="logo">
      
      <!-- Menu desktop -->
      <nav class="desktop-menu">
        <ul>
          <li><a href="#about">ABOUT</a></li>
          <!-- li><a href="#about">OUR STORY</a></li -->
          <li><a href="#sustainability">susteinability</a></li>
          <li><a href="#be-a-part">BE A PART</a></li>
          <!-- li><a href="#">CONTACT</a></li -->
          <component_bt_contact buttonText="Contact"  buttonClass="btnx1" />
        </ul>
      </nav>

      <!-- Ícone menu mobile -->
      <button class="menu-toggle" @click="toggleMenu">
        ☰
      </button>
    </header>

    <!-- Menu mobile -->
    <transition name="slide">
      <div v-if="showMobileMenu" class="mobile-menu">
        <ul>
          <li><a href="#about" @click="toggleMenu">ABOUT</a></li>
          <li><a href="#sustainability" @click="toggleMenu">susteinability</a></li>
          <li><a href="#be-a-part"  @click="toggleMenu">BE A PART</a></li>
          <component_bt_contact buttonText="Contact"  buttonClass="btnx2" />
        </ul>

        
        <button class="close-menu" @click="toggleMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="87.681" height="87.681" viewBox="0 0 87.681 87.681">
            <g id="close" transform="translate(-3030.159 -5286.16)">
<line id="Linha_11" data-name="Linha 11" y2="122" transform="translate(3117.134 5286.867) rotate(45)" fill="none" stroke="#475c37" stroke-width="2"/>
<line id="Linha_12" data-name="Linha 12" y2="122" transform="translate(3030.866 5286.867) rotate(-45)" fill="none" stroke="#475c37" stroke-width="2"/>
</g>
</svg>
</button>


      </div>
    </transition>

    <!-- Conteúdo central -->
    <div class="content">

      <a href="#about">
      <svg xmlns="http://www.w3.org/2000/svg" width="83.085" height="43.679" viewBox="0 0 83.085 43.679">
                    <path id="Caminho_7" data-name="Caminho 7"
                        d="M162.824,44.164,164.643,46l39.718-40,39.73,40.015,1.819-1.832L204.361,2.328Z"
                        transform="translate(245.91 46.007) rotate(180)" fill="#E0D0A6" />
                </svg>
                </a>

    </div>
 
    
  </div>
 
</template>

<script>

 import component_bt_contact from '@/components/component_bt_contact.vue'



export default {
  name: 'ImageBackgroundComponent',


  data() {
    return {
      showMobileMenu: false
    }
  },


  components: {
    component_bt_contact,
  },
  
  
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    }
  }
}
</script>

<style scoped>

:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --blue2: #83DEF4;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

 

.border-log {
      border: 4px solid rgb(0, 0, 255);
}


.desktop-menu ul {
  border: 0px solid rgb(0, 0, 255);
  gap: 4rem;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  justify-content: space-between;
  color: var(--cream);
  font-family: 'Object Sans';
  align-items: center;
  letter-spacing: 0.15rem
}

.desktop-menu li {
  margin: 20px;
}

.desktop-menu a {
  text-decoration: none;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 2rem;
}




.video-container {
  top: 0; /* Começa no topo */
  left: 0; /* Começa na esquerda */
  width: 100%; /* Largura 100% da tela */
  height: 100%; /* Altura 100% da tela */
  z-index: -1; /* Coloca o vídeo atrás do conteúdo da página */
}


.background-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url('../assets/bg04.jpg');
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.header {
  border: 0px solid rgb(0, 0, 255);
  position: absolute;
  top: 0;
  width: 100%;
  height: 400px;
  padding: 4rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  z-index: 11;
  background: linear-gradient(to bottom, rgba(0, 51, 0, 0.9) 0%, rgba(0, 51, 0, 0.6) 50%, rgba(61, 77, 49, 0.1) 90%, transparent 100%);
}

.logo {
  width: 28.6rem;
  height: auto;
  opacity: 1;
  fill: white
}

.content {
  position: absolute;
  top: 90%;
  left: 90%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 10;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.cta-button {
  padding: 10px 20px;
  font-size: 1rem;
  background: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  z-index: 12;
  color: var(--cream);
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 250px;
  height: 100%;
  background: var(--cream);
  z-index: 11;
  display: none;


  
}

.mobile-menu ul {
  list-style: none;
  padding: 20px;
  margin: 0;
  border: 0px solid rgb(0, 0, 255);
  gap: 4rem;
  list-style: none;
  text-transform: uppercase;
  justify-content: space-between;
  color: var(--cream);
  font-family: 'Object Sans';
  align-items: center;
  letter-spacing: 0.15rem;  
  font-size: 1.2rem;
}

.mobile-menu li {
  margin: 20px 0;
}

.mobile-menu a {
  color: var(--green);
  text-decoration: none;
  font-size: 2.2rem;
  cursor: pointer;
}

.close-menu {
  position: absolute;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  text-align: center;
  place-items: center;      
  top: 40%;
  left: 25%;
}

/* Animação do menu mobile - da direita para a esquerda */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

/* Media queries para mobile */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .menu-toggle {
    display: block;
  }

  .mobile-menu {
    display: block;
  }

  h1 {
    font-size: 1.8rem;
  }

  h2 {
    font-size: 1.2rem;
  }

  .logo {
    width: 180px;
  }


  .content {
    position: absolute;
    top: 85%;
    left: 80%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 10;
  }

}
</style>